"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cosenza": {
    "695685fb": [{
      "hkey": "495416b4",
      "slug": "panebianco-tribunale",
      "name": "Panebianco-Tribunale",
      "primary": true,
      "skipSearch": false
    }],
    "c-so-italia": [{
      "hkey": "495416b4",
      "slug": "panebianco-tribunale",
      "name": "Panebianco-Tribunale",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cosenza"
    }],
    "6008e9f0": [{
      "hkey": "a7282b18",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "loreto": [{
      "hkey": "a7282b18",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "b7c6e8e3": [{
      "hkey": "a7282b18",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "mazzini": [{
      "hkey": "a7282b18",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cosenza"
    }],
    "49645ea8": [{
      "hkey": "4b7d8763",
      "slug": "acquedotto",
      "name": "Acquedotto",
      "primary": true,
      "skipSearch": false
    }],
    "muoio-piccolo": [{
      "hkey": "4b7d8763",
      "slug": "acquedotto",
      "name": "Acquedotto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cosenza"
    }],
    "4a703dc3": [{
      "hkey": "a7282b18",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "repubblica": [{
      "hkey": "a7282b18",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cosenza"
    }],
    "9ea9cc53": [{
      "hkey": "495416b4",
      "slug": "panebianco-tribunale",
      "name": "Panebianco-Tribunale",
      "primary": true,
      "skipSearch": false
    }],
    "via-panebianco": [{
      "hkey": "495416b4",
      "slug": "panebianco-tribunale",
      "name": "Panebianco-Tribunale",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "287baab5": [{
      "hkey": "547da0f9",
      "slug": "mancini-popilia",
      "name": "Mancini-Popilia",
      "primary": true,
      "skipSearch": false
    }],
    "via-popilia": [{
      "hkey": "547da0f9",
      "slug": "mancini-popilia",
      "name": "Mancini-Popilia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cosenza"
    }],
    "f72d0c17": [{
      "hkey": "a7282b18",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "via-roma": [{
      "hkey": "a7282b18",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cosenza"
    }],
    "97fae714": [{
      "hkey": "547da0f9",
      "slug": "mancini-popilia",
      "name": "Mancini-Popilia",
      "primary": true,
      "skipSearch": false
    }],
    "viale-mancini": [{
      "hkey": "547da0f9",
      "slug": "mancini-popilia",
      "name": "Mancini-Popilia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "bcdab742": [{
      "hkey": "a7282b18",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "viale-trieste": [{
      "hkey": "a7282b18",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cosenza"
    }]
  }
};
exports["default"] = _default;